export class Definicion {
    constructor(
        public id: String = "",
        public codigo: String = "",
        public descripcion: String = "",
        public status: String = "",
        public fecha_ingreso: String = "",
        public usuario_id: String = "",
        public fecha_modifica: String = "",
        public usuario_modifica_id: String = "",
        public fecha_elimina: String = "",
        public usuario_elimina_id: String = "",
        )
         
	{}
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/definicion.ts